export const COLLECTIONS = {
  USERS: "users",
  VEHICLES: "vehicles",
  CATEGORIES: "categories",
  BRANDS: "brands",
  WISHLIST_ITEMS: "wishlistItems",
  ADDRESSES: "addresses",
  PAYMENT_METHODS: "paymentMethods",
  ORDERS: "orders",
  PAYMENTS: "payments",
  BANK_TRANSFERS: "bankTransfers",
  FINANCING_REQUESTS: "financingRequests",
  CASH_PURCHASE_REQUESTS: "cashPurchaseRequests",
  INVOICES: "invoices",
  SHIPPING_AGENCIES: "shippingAgencies",
  PAYMENT_GATEWAYS: "paymentGateways",
  BANK_ACCOUNTS: "bankAccounts",
  SALE_OFFERS: "saleOffers",
  ANNOUNCEMENTS: "announcements",
  STORE_CONFIG: "storeConfig",
  HOME_SECTIONS: "homeSections",
  HOME_CONFIGS: "homeConfigs",
  ADMIN_SETTINGS: "adminSettings",
  INSTALLMENT_PLANS: "installmentPlans",
  NOTIFICATIONS: "notifications",
  ADMIN_NOTIFICATIONS: "adminNotifications",
  REVIEWS: "reviews",
  SOCIAL_POSTS: "socialPosts",
  RAFFLES: "raffles",
  RAFFLE_ENTRIES: "raffleEntries",
  USER_STATS: "userStats",
  MODERATION_ACTIONS: "moderationActions",
  // Repuestos (usado en frontend)
  PARTS: "parts",
  PART_CATEGORIES: "part_categories",
  PART_BRANDS: "part_brands",
  QUOTES: "quotes",
  QUOTE_REQUESTS: "quote_requests",
} as const;
